package dev.lingvo.shared.screenshots.render

import dev.lingvo.shared.screenshots.doc.Palette
import dev.lingvo.shared.screenshots.doc.Point
import dev.lingvo.shared.screenshots.doc.ShapeKind
import dev.lingvo.shared.screenshots.doc.ShapeLayer
import dev.lingvo.shared.screenshots.geom.Rect

internal fun paintShape(layer: ShapeLayer, rect: Rect, palette: Palette, slot: Int, surface: Surface) {
    val path = when (layer.shape) {
        ShapeKind.RECT -> Paths.roundedRect(rect, layer.cornerRadius)
        ShapeKind.ELLIPSE -> Paths.ellipse(rect)
        ShapeKind.LINE -> PathBuilder().moveTo(0.0, 0.0).lineTo(rect.w, rect.h).build()
        ShapeKind.CURVE -> curvePath(layer.points)
    }
    layer.fill?.let { surface.fill(path, resolvePaint(it, rect, palette, slot)) }
    layer.stroke?.let { surface.stroke(path, resolvePaint(it.paint, rect, palette, slot), StrokeStyle(it.width, dash = it.dash)) }
}

/** Catmull-Rom knots become cubics so arbitrary-length ribbons remain smooth without platform arc APIs. */
internal fun curvePath(points: List<Point>): Path {
    if (points.isEmpty()) return Path(emptyList())
    val path = PathBuilder().moveTo(points.first().x, points.first().y)
    for (i in 0 until points.lastIndex) {
        val p0 = points[maxOf(0, i - 1)]
        val p1 = points[i]
        val p2 = points[i + 1]
        val p3 = points[minOf(points.lastIndex, i + 2)]
        path.cubicTo(p1.x + (p2.x - p0.x) / 6, p1.y + (p2.y - p0.y) / 6,
            p2.x - (p3.x - p1.x) / 6, p2.y - (p3.y - p1.y) / 6, p2.x, p2.y)
    }
    return path.build()
}
